import { cn } from '../lib/cn.ts';

export type ProjectHue = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

/** A project's stable hue among the eight data slots (a hash of its id), the same on every page. */
export function projectHue(projectId: string): ProjectHue {
  let h = 0;
  for (let i = 0; i < projectId.length; i++) h = (h * 31 + projectId.charCodeAt(i)) >>> 0;
  return ((h % 8) + 1) as ProjectHue;
}

const TILE: Record<ProjectHue, string> = {
  1: 'bg-data-1/14 text-data-1',
  2: 'bg-data-2/14 text-data-2',
  3: 'bg-data-3/14 text-data-3',
  4: 'bg-data-4/14 text-data-4',
  5: 'bg-data-5/14 text-data-5',
  6: 'bg-data-6/14 text-data-6',
  7: 'bg-data-7/14 text-data-7',
  8: 'bg-data-8/14 text-data-8',
};

const SIZE = { xs: 'size-4 text-caption', sm: 'size-6 text-caption', md: 'size-8 text-ui' } as const;

/**
 * A project's mark: its first letter in a small rounded tile of its own hue, so a project reads
 * the same in every list, flow and header. Decorative: the name beside it is the label. No
 * project: a quiet neutral tile.
 */
export function ProjectMark({ projectId, name, size = 'sm', className }: { projectId: string | null; name: string; size?: keyof typeof SIZE; className?: string }) {
  const letter = (name.trim()[0] ?? '?').toUpperCase();
  return (
    <span
      aria-hidden
      className={cn('inline-flex shrink-0 items-center justify-center rounded-control font-semibold leading-none', SIZE[size], projectId ? TILE[projectHue(projectId)] : 'bg-active text-fg-subtle', className)}
    >
      {letter}
    </span>
  );
}
